<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor';

/**
 * Renderless wrapper that hands a field's vuelidate state to its slot as
 * `{ hasErrors, message }`.
 *
 * The legacy `text-area` printed that message itself, because the kit's
 * `TextArea.vue` mixes in `singleErrorExtractorMixin`. The rebuilt tabs use a
 * plain `<textarea>` inside a `gs-field`, which has no validator of its own,
 * so the same mixin is reused here rather than re-deriving the copy from the
 * message templates in `plugins/vuelidate.js` — the wording stays identical
 * and stays in one place if those templates ever change.
 *
 * Usage:
 *   <field-error :validator="$v.…" :attribute="$t('…')">
 *     <template #default="{ hasErrors, message }">
 *       <gs-field :label="…" :error="message">
 *         <textarea class="gs-textarea" :class="{ 'has-error': hasErrors }" …></textarea>
 *       </gs-field>
 *     </template>
 *   </field-error>
 */
export default {
  name: 'FieldError',

  mixins: [singleErrorExtractorMixin],

  render() {
    const nodes = this.$scopedSlots.default({
      hasErrors: this.hasErrors,
      // `firstErrorMessage` is only meaningful once the field is dirty, so it
      // is gated on `hasErrors` to keep `gs-field`'s `error` prop empty until
      // the user (or Save) has touched the form.
      message: this.hasErrors ? this.firstErrorMessage : '',
    });

    // Vue 2 scoped slots return an array; the wrapper must return one root.
    return Array.isArray(nodes) ? nodes[0] : nodes;
  },
};
</script>
